export let mdsPublicJson: any, frontendOperators: any

export const setMdsPublicJson = (data: any) => (mdsPublicJson = data)
export const setFrontendOperators = (data: any) => (frontendOperators = data)
